import lazyLoad from 'app/shared-components/util/lazyLoad';
import BookingConfig from '../booking/BookingConfig';

const PublicProfile = lazyLoad(() => import('./PublicProfile'));

const PublicProfileConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: true,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: true,
        },
      },
    },
  },
  auth: null, //anyone
  routes: [
    {
      path: 'public/profile/:id',
      element: <PublicProfile />,
    },
    ...BookingConfig.routes.map(route => ({
      ...route,
      path: `public/profile/:id/${route.path}`
    }))
  ],
};

export default PublicProfileConfig;


